<template>
  <div class="card shadow-sm border-0 mb-4 product-card-height">
    <img class="card-img-top" :src="getImage(cloneProduct.images.full.url)" alt="P" />
    <div class="card-body product-card">
      <div class="product-card-top">
        <h5 class="card-title" style="overflow: hidden">
          {{ cloneProduct.name }}
        </h5>
        <div>
          SKU: <b>{{ cloneProduct.sku.substring(0, 13) || cloneProduct.id.substring(0, 13) }}</b>
          <br />
          Stock: <b>{{ setStockProduct(cloneProduct.stock) }}</b>
          <br />

          <div v-if="!isIntimo" class="price">
            Precio:
            <span :class="{ decoration: cloneProduct.offerPrice }">
              <b> {{ cloneProduct.currency.symbol }} {{ cloneProduct.price }} </b>
            </span>
            <span v-if="cloneProduct.offerPrice" class="ml-3">
              <b> {{ cloneProduct.currency.symbol }} {{ cloneProduct.offerPrice }} </b>
            </span>
          </div>

          <div v-else class="isSpecialPrice">
            <span>Precio: </span>
            <span class="ml-1" :class="{ decoration: !intimoPrice && cloneProduct.offerPrice }">
              <b>{{ cloneProduct.currency.symbol }} {{ cloneProduct.price }} </b>
            </span>
            <span v-if="!intimoPrice && cloneProduct.offerPrice" class="ml-3">
              <b> {{ cloneProduct.currency.symbol }} {{ cloneProduct.offerPrice }} </b>
            </span>
            <div v-if="intimoPrice" class="isSpecialPrice-text"><span>Intimo</span></div>
          </div>
          
          <ProductVariations
            v-if="hasVariations && !loadingStock"
            :variations="setVariations"
            @assignVariations="assignVariations"
            :key="cloneProduct.id"
            style="margin: .5rem 0;"
          />
        </div>
        <div v-if="isDeliveryProccess">
          <div class="row" v-if="isDeliveryProccess && hasVariations">
            <div class="col-8">
              <ProductVariations
                :variations="setVariations"
                @assignVariations="assignVariations"
                :key="cloneProduct.id"
              />
            </div>
            <div class="col-4">
              <ModalCustomize
                :variations="variations"
                :product="cloneProduct"
                :customize="customize"
                :key="cloneProduct.id"
                @getProducts="$emit('getProducts')"
              />
            </div>
          </div>
          <div v-if="isDeliveryProccess && !hasVariations" class="notVariantions"></div>
        </div>
      </div>
      <div class="product-card-bottom">
        <div v-if="cloneProduct.stock > 0" class="row justify-content-between">
          <div class="col mb-2">
            <CounterInput
              v-model="cloneProduct.quantity"
              :limit="Number(cloneProduct.stock)"
              :variations="variations"
              :disabled="cloneProduct.stock == 0 || cloneProduct.stock == undefined ? true : false"
            />
          </div>
          <div class="col-12 col-sm-auto">
            <button
              @click="addToCart()"
              class="btn btn-action btn-block"
              type="button"
              :disabled="disabledAddCart"
            >
              Agregar
            </button>
          </div>
        </div>
        <p v-else style="color: red; text-align: center; margin: .5rem 0;">Agotado</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';

export default {
  props: ['product', 'isIntimo'],
  created() {
    this.getStock();
  },
  data() {
    return {
      loadingStock: true,
      variations: {},
      customize: [],
      cloneProduct: this.product
    };
  },
  watch: {
    'product.quantity'() {
      this.createdArrayCustomize();
    },
    isIntimo: {
      immediate: true,
      handler(value){
        value && this.setIntimoPrice();
      }
    }
  },
  computed: {
    setVariations() {
      return this.cloneProduct ? this.cloneProduct.variations.data : [];
    },
    disabledAddCart() {
      if (this.hasVariations) {
        if (this.variations) {
          return this.variations.stock > 0 && this.cloneProduct.quantity > 0 ? false : true;
        } else {
          return true;
        }
      } else {
        return this.cloneProduct.quantity > this.cloneProduct.stock || !this.cloneProduct.stock
          ? true
          : false;
      }
    },
    hasVariations() {
      return this.setVariations.length > 0 ? true : false;
    },
    // el precio intimo del producto
    intimoPrice(){
      let res = 0;
      // "specialPrices": si no hay variaciones es un Array
      // si hay es un Objeto
      const { specialPrices } = this.cloneProduct;
      if (specialPrices) {
        if (Array.isArray(specialPrices)) {
          res = specialPrices[0].price;
        } else {
          const cb = (elem) => elem.variationId == this.variations.id;
          const specialPrice = specialPrices.intimo.find(cb);
          res = specialPrice && specialPrice.price;
        }
      }
      return res;
    },
    // this.$store.getters.getIsDeliveryProccess no se esta usando parece
    isDeliveryProccess() {
      return this.$store.getters.getIsDeliveryProccess;
    },
    isSpecialPrice() {
      const { specialPrices } = this.cloneProduct;
      if (this.cloneProduct && specialPrices) {
        if (Array.isArray(specialPrices)) {
          return true;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    addToCart() {
      const { quantity, stock } = this.cloneProduct;
      //Variations
      if (Object.keys(this.variations).length !== 0) {
        const cloneProduct = { ...this.cloneProduct };
        delete cloneProduct.variations;
        cloneProduct.variations = this.variations;
        cloneProduct.variationId = this.variations.id;
        if (this.variations.stock >= quantity) {
          this.$emit('add-cart', cloneProduct);
        }
      } else {
        if (quantity > stock || !quantity) return;
        const cloneProduct = { ...this.cloneProduct };
        delete cloneProduct.variations;
        cloneProduct.variations = '';
        this.$emit('add-cart', cloneProduct);
      }
    },
    async getStock() {
      const { id } = this.cloneProduct;
      this.loadingStock = true;
      const data = await api.getStock(id);
      this.cloneProduct.stock = data.stock;
      this.loadingStock = false;
    },
    setStockProduct(stock) {
      if (!this.hasVariations) {
        if (stock) {
          return stock;
        } else {
          return 'Agotado';
        }
      } else {
        return this.variations.stock > 0 ? this.variations.stock : 'Agotado';
      }
    },
    getImage(imgUrl) {
      return imgUrl.includes('[]')
        ? imgUrl
        : imgUrl.includes('[{')
        ? JSON.parse(imgUrl)[0].imageurl
        : imgUrl;
    },
    assignVariations(value) {
      this.changeIntimoPrice(value);
    },
    // setea el precio intimo al producto
    setIntimoPrice() {
      if(this.intimoPrice) this.cloneProduct.price = this.intimoPrice
    },
    changeIntimoPrice(variation) {
      this.variations = variation;

      this.cloneProduct.price = variation.price;
      this.cloneProduct.offerPrice = variation.offerPrice;
      this.cloneProduct.stock = variation.stock;
      this.cloneProduct.quantity = variation.quantity || 1;

      if (this.isIntimo) this.setIntimoPrice()
    },
    createdArrayCustomize() {
      this.customize = [];
      if (this.cloneProduct.quantity > 0) {
        let len = this.cloneProduct.quantity;
        for (let i = 1; i <= len; i++) {
          this.customize.push({
            id: i,
            number: '',
            name: ''
          });
        }
      }
    }
  }
};
</script>

